import { TemplateElement, html, toString, defineElement } from '@webtides/element-js';
import style from './buy-box-variants.css';
import '../buy-box-spec/buy-box-spec';
import SelectedSpecs from '../SelectedSpecs';
import ProductPageEvents from '../../../cms-pages/product-page/ProductPageEvents';

export default class BuyBoxVariants extends TemplateElement {
    constructor() {
        super({ shadowRender: false, styles: [style], deferUpdate: true });
    }

    connected() {
        this.requestUpdate();
    }

    properties() {
        return {
            specs: {},
            specOptions: {},
            specOptionsLinks: {},
            selectedSpecs: null,
        };
    }

    events() {
        return {
            this: {
                'spec-changed': ({ detail: { name, value, index } }) => {
                    const selectedClone = this.selectedSpecs.clone();
                    selectedClone.set(name, value);
                    this.dispatch(
                        'specs-changed',
                        {
                            spec: name,
                            selectedIndex: index,
                            selectedSpecs: selectedClone,
                        },
                        true
                    );
                },
            },
        };
    }

    template() {
        return html`
            ${Object.entries(this.specOptions).map(
                ([key, spec]) =>
                    html`
                        <div class="buy-box-variant-group">
                            <div class="spec-label xl:w-1/3 flex flex-wrap items-baseline lg:block">
                                <div class="mr-2">${spec.label}</div>
                                ${this.specLink(key)}
                            </div>
                            <buy-box-spec
                                spec-name="${spec.name}"
                                spec="${toString(this.specOptions[spec.name])}"
                                .selectedSpecs="${this.selectedSpecs}"
                                class="xl:ml-4 xl:w-2/3"
                            ></buy-box-spec>
                        </div>
                    `
            )}
        `;
    }

    specLink(key) {
        if (!this.specOptionsLinks.hasOwnProperty(key) || !this.specOptionsLinks[key].href) return '';
        const link = this.specOptionsLinks[key];

        return html`
            <div class="spec-link">
                ${link.type === 'modal'
                    ? html`
                          <modal-trigger class="cursor-pointer" target-modal="${link.href}"
                              >${link.label}</modal-trigger
                          >
                      `
                    : html` <a target="${link.target}" rel="${link.rel}" href="${link.href}">${link.label}</a> `}
            </div>
        `;
    }
}

defineElement('buy-box-variants', BuyBoxVariants);
